"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=commercial-rule.dto.js.map